"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyClassName = function (className, 
// Value suffix added to the className
value, options) {
    if (options === void 0) { options = {}; }
    var viewport = options.viewport;
    var base = viewport === "s" || !viewport;
    if (value === undefined)
        return null;
    // We add boolean value to the className to be able to reset the styles back to default on other viewports
    var valueString = value.toString();
    var suffix = viewport && !base ? "--".concat(viewport) : "";
    return "".concat(className, "-").concat(valueString).concat(suffix);
};
exports.default = applyClassName;
